(function() {
  // Create namespaced logger
  const Logger = window.ShopLogger ? 
    window.ShopLogger.createLogger('CartWatcher') : 
    { error: console.error, warn: console.warn, info: () => {}, debug: () => {} };

  class CartWatcher {
    constructor() {
      this.ignoreNextChange = false;
    }

    init() {
      this.emitCartChanges().then(() => {
        this.observeCartChanges();
      });
    }

    async fetchCart() {
      const response = await fetch('/cart.js');
      return response.json();
    }

    storeCart(cart) {
      localStorage.setItem('cart', JSON.stringify(cart));
    }

    storedCart() {
      return JSON.parse(localStorage.getItem('cart')) || { items: [] };
    }

    findCartChanges(oldCart, newCart) {
      const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key === ri.key));
      let result = {
        added: onlyInLeft(newCart.items, oldCart.items),
        removed: onlyInLeft(oldCart.items, newCart.items),
      };

      oldCart.items.forEach(oi => {
        const ni = newCart.items.find(i => i.key === oi.key && i.quantity !== oi.quantity);
        if (!ni) return;
        let quantity = ni.quantity - oi.quantity;
        let item = { ...ni };
        item.quantity = Math.abs(quantity);
        quantity > 0
          ? result.added.push(item)
          : result.removed.push(item);
      });

      return result;
    }

    async emitCartChanges() {
      const newCart = await this.fetchCart();
      const oldCart = this.storedCart();

      if (JSON.stringify(oldCart) === JSON.stringify(newCart)) {
        return;
      }

      const changes = this.findCartChanges(oldCart, newCart);
      Logger.debug('changes', changes);

      const onlyQuantityChanged = changes.added.length === 1 && changes.removed.length === 1 &&
        changes.added[0].variant_id === changes.removed[0].variant_id &&
        changes.added[0].quantity === changes.removed[0].quantity;

      if (!onlyQuantityChanged && changes.removed.length > 0) {
        Logger.debug('hitting the cart change event');
        const event = new CustomEvent("cart_changed", { detail: changes });
        window.dispatchEvent(event);
      }

      this.storeCart(newCart);
    }

    observeCartChanges() {
      const cartObserver = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
          const isCartChangeRequest = /\/cart\//.test(entry.name);
          if (isValidRequestType && isCartChangeRequest) {
            this.emitCartChanges();
          }
        });
      });
      cartObserver.observe({ entryTypes: ["resource"] });
    }

    ignoreNextEmit() {
      this.ignoreNextChange = true;
    }
  }

  // Expose the class to the global scope
  window.CartWatcher = CartWatcher;
})();
